import styled, { css } from 'styled-components'
import type { InterpolationValue } from 'styled-components'
import ellipsis from 'polished/lib/mixins/ellipsis'
import { colors, sizes } from 'config/ui'
import Autocomplete from 'components/autocomplete'

type ContentCoverProps = {
  img: string
}

export const Form = styled.form`
  width: 335px;
  @media (max-width: ${sizes.sScreen}px) {
    width: auto;
    padding: 17px;
  }
`

export const Field = styled.div`
  margin-bottom: 20px;
  position: relative;
`

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const Item = styled.li`
  padding: 10px 0;
  border-bottom: 1px solid ${colors.lightGray};
`

export const IndicatedTo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Link = styled.a`
  text-decoration: underline;
  font-size: ${sizes.smallText}px;
  color: ${colors.gray};
  cursor: pointer;
`

export const Book = styled.div`
  display: flex;
`

export const BookCover = styled.div<ContentCoverProps>`
  ${({ img }) => css`
    background-image: url('${img}');
    background-size: cover;
    min-width: 93px;
    height: 138px;
    border-radius: ${sizes.radius}px;
    display: inline-block;
  `};
`

export const BookInfos = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`

export const BookTitle = styled.div`
  ${ellipsis('200px') as InterpolationValue[]};
`

export const BookAuthor = styled.div`
  margin: 5px 0 10px 0;
  color: ${colors.gray};
`

export const StyledAutoComplete = styled(Autocomplete)`
  width: 315px;
  margin-top: -26px;
  max-height: 276px;
  overflow: auto;
`

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    color: ${colors.black};
  }
`

export const InfoAlertWrapper = styled.div`
  margin-bottom: 20px;

  > div {
    padding-left: 4px;
    min-height: fit-content;

    > div {
      align-items: flex-start;

      > div {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  }
`
